






























import Vue from "vue";
import { Prop, Component, Model } from "vue-property-decorator";

/**
 * Utils
 */
import * as imageLinks from "@/config/image-links";

/**
 * Tab list of the compositions.
 */
@Component
export default class CompositionsTabList extends Vue {
	/// Injections
	imageLinks = imageLinks;

	@Model("change", {type: Number})
	readonly index!: number;

	@Prop()
	compositions!: any[];

	@Prop({default: false, type: Boolean})
	hideUnused!: boolean;

	created() {
		const firstIndexSelected = this.compositions.findIndex(x => this.hideUnused ? x.characters.length > 0 : true);
		this.emitChange(firstIndexSelected);
	}

	emitChange(newIndex: number) {
		this.$emit("change", newIndex);
	}
}
